import { common } from '@ocean/ui'
import { ListItemLayout, ListItemSegment } from 'layouts/lists'
import { List } from 'components/lists'

const { ContentTrace, Translucent } = common.skeletonStyles

const ListSkeleton: React.FC = () => (
  <Translucent opacity='0.7' data-test='ListSkeleton'>
    <List>
      <ListItemLayout>
        <ListItemSegment segmentId='header'>
          <ContentTrace width='25%' color='greyLight' />
          <br />
        </ListItemSegment>
        <ListItemSegment segmentId='content'>
          <ContentTrace width='65%' color='greyLight' />
        </ListItemSegment>
        <ListItemSegment segmentId='sidebar'>
          <ContentTrace width='100px' color='greyLight' />
        </ListItemSegment>
      </ListItemLayout>
      <ListItemLayout>
        <ListItemSegment segmentId='header'>
          <ContentTrace width='35%' color='greyLight' />
          <br />
        </ListItemSegment>
        <ListItemSegment segmentId='content'>
          <ContentTrace width='60%' color='greyLight' />
        </ListItemSegment>
        <ListItemSegment segmentId='sidebar'>
          <ContentTrace width='70px' color='greyLight' />
        </ListItemSegment>
      </ListItemLayout>
      <ListItemLayout>
        <ListItemSegment segmentId='header'>
          <ContentTrace width='30%' color='greyLight' />
          <br />
        </ListItemSegment>
        <ListItemSegment segmentId='content'>
          <ContentTrace width='50%' color='greyLight' />
        </ListItemSegment>
        <ListItemSegment segmentId='sidebar'>
          <ContentTrace width='80px' color='greyLight' />
        </ListItemSegment>
      </ListItemLayout>
    </List>
  </Translucent>
)

export default ListSkeleton
